import React, { useEffect, useState } from "react";
import { COLORS } from "../../config";
import useScans from "../../store/scans/scansContext";
import STLViewer from "../../components/Viewers/STLViewer";

function STLViewerPage({ scanId, scanName }) {
  const { getScanFile } = useScans();

  const [url, setUrl] = useState();
  const [patientName, setPatientName] = useState();
  const [color, setColor] = useState(COLORS.colorPrimary);

  useEffect(() => {
    getScanFile(scanId, scanName).then((data) => {
      setUrl(data?.downloadUrl);
      setPatientName(data?.patientName);
    });
  }, [scanId, scanName]);

  return (
    <div className="flex flex-col items-center w-full my-5 stl-viewer">
       <div className="flex mb-3">
        <div className="font-bold mr-1">Patient Name:</div>
        <div className="">{patientName} </div>
      </div>
      <div className="flex mb-3">
        <div className="font-bold mr-1">File Name:</div>
        <div className="">{scanName}</div>
      </div>
      {/* <div className="flex mb-8">
        <PopoverPicker color={color} onChange={setColor} />
      </div> */}
      {url && (
        <div style={{ backgroundColor: "#999999" }}>
          <STLViewer url={url} width={1000} height={600}/>
        </div>
      )}
    </div>
  );
}

export default STLViewerPage;
